import React, { useState, useEffect } from 'react';
import { Form, Button, Alert, ListGroup, Table } from 'react-bootstrap';
import { adminInstance } from '../services/axiosInstance'; 
import { useParams } from 'react-router-dom';

const FileUploadComponent = () => {
  const { subGroupId } = useParams();
  const [path, setPath] = useState([]);
  const [files, setFiles] = useState([]);
  const [error, setError] = useState('');
  const [existingFiles, setExistingFiles] = useState([]);

  const maxSize = 4 * 1024 * 1024; // 4MB

  useEffect(() => {
    fetchExistingFiles();
  }, []);

  const fetchExistingFiles = async () => {
    try {
      const response = await adminInstance.get(`subgroupfiles/Getfiles?productId=${subGroupId}`);
      setExistingFiles(response.data.files || []);
      setPath(response.data.path);
    } catch (err) {
      setError('Failed to load existing files.');
    }
  };

  const handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files);
    const invalidFiles = selectedFiles.filter(file => file.size > maxSize);

    if (invalidFiles.length > 0) {
      setError('Each file must be less than 4MB.');
      setFiles([]);
      return;
    }

    setError('');
    setFiles(selectedFiles);
  };

  const handleSubmit = async () => {
    if (files.length === 0) {
      setError('Please select files.');
      return;
    }

    const formData = new FormData();
    files.forEach(file => formData.append('files', file));

    try {
      //await axios.post('/api/upload', formData);
      await adminInstance.post(`subgroupfiles/upload?productId=${subGroupId}`, formData, {
              headers: { "Content-Type": "multipart/form-data" },
            });
      setFiles([]);      
      await fetchExistingFiles();
      alert('Files uploaded successfully');
    } catch (err) {
      setError('Upload failed. Please try again.');
    }
  };

  const handleDelete = async (fileName) => {
    if (!window.confirm(`Are you sure you want to delete "${fileName}"?`)) return;

    try {
      await adminInstance.delete(`subgroupfiles/delete?productId=${subGroupId}&fileName=${encodeURIComponent(fileName)}`);
      await fetchExistingFiles(); // Refresh file list after deletion
      alert('Files deleted successfully');
    } catch (error) {
      console.error('Error deleting file', error);
      alert('Failed to delete the file.');
    }
  };

  return (
    <div className="card aon-card">
    <div className="card-header aon-card-header">
        <h4>
            Product File Manager
        </h4>
    </div>
    <div className="card-body aon-card-body">
    <div className="container">
      <Form>
        <Form.Group>
          <Form.Label>Select Files (Max 4MB each)</Form.Label>
          <Form.Control type="file" multiple onChange={handleFileChange} />
        </Form.Group>
        {error && <Alert variant="danger">{error}</Alert>}
        <Button variant="primary" onClick={handleSubmit}>Upload</Button>
      </Form>

      <h5 className="mt-4">📂 Existing Files</h5>
      {existingFiles.length > 0 ? (
        <Table bordered hover responsive>
          <thead>
            <tr>
              <th>File Name</th>
              <th>Action</th>
              <th>Delete</th>
            </tr>
          </thead>
          <tbody>
            {existingFiles.map((file, index) => (
              <tr key={index}>
                <td>{file}</td>
                <td>
                  <a
                    href={`${path}/${subGroupId}/${file}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    View
                  </a>
                </td>
                <td>
                  <Button variant="danger" onClick={() => handleDelete(file)}>Delete</Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      ) : (
        <p>No files uploaded yet.</p>
      )}      
    </div>
    </div>
    </div>
  );
};

export default FileUploadComponent;
